var map = {
	"./SpinLago_001.webp": 23947,
	"./SpinLago_002.webp": 18337,
	"./SpinLago_003.webp": 12368,
	"./SpinLago_004.webp": 7487,
	"./SpinLago_005.webp": 80934,
	"./SpinLago_006.webp": 29668,
	"./SpinLago_007.webp": 54175,
	"./SpinLago_008.webp": 49349,
	"./SpinLago_009.webp": 77472,
	"./SpinLago_010.webp": 77904,
	"./SpinLago_011.webp": 55444,
	"./SpinLago_012.webp": 10366,
	"./SpinLago_013.webp": 92449,
	"./SpinLago_014.webp": 69745,
	"./SpinLago_015.webp": 2164,
	"./SpinLago_016.webp": 84625,
	"./SpinLago_017.webp": 58120,
	"./SpinLago_018.webp": 53846,
	"./SpinLago_019.webp": 32114,
	"./SpinLago_020.webp": 6762,
	"./SpinLago_021.webp": 19056,
	"./SpinLago_022.webp": 22431,
	"./SpinLago_023.webp": 88050,
	"./SpinLago_024.webp": 5893,
	"./SpinLago_025.webp": 90594,
	"./SpinLago_026.webp": 32843,
	"./SpinLago_027.webp": 59498,
	"./SpinLago_028.webp": 91860,
	"./SpinLago_029.webp": 90982,
	"./SpinLago_030.webp": 51402,
	"./SpinLago_031.webp": 79540,
	"./SpinLago_032.webp": 26941,
	"./SpinLago_033.webp": 55574,
	"./SpinLago_034.webp": 20185,
	"./SpinLago_035.webp": 74878,
	"./SpinLago_036.webp": 72462,
	"./SpinLago_037.webp": 27252,
	"./SpinLago_038.webp": 34316,
	"./SpinLago_039.webp": 56832,
	"./SpinLago_040.webp": 31319,
	"./SpinLago_041.webp": 68113,
	"./SpinLago_042.webp": 94905,
	"./SpinLago_043.webp": 9461,
	"./SpinLago_044.webp": 13212,
	"./SpinLago_045.webp": 26819,
	"./SpinLago_046.webp": 74490,
	"./SpinLago_047.webp": 6633,
	"./SpinLago_048.webp": 40339,
	"./SpinLago_049.webp": 4392,
	"./SpinLago_050.webp": 76857,
	"./SpinLago_051.webp": 44198,
	"./SpinLago_052.webp": 91419,
	"./SpinLago_053.webp": 87712,
	"./SpinLago_054.webp": 15026,
	"./SpinLago_055.webp": 28909,
	"./SpinLago_056.webp": 87088,
	"./SpinLago_057.webp": 326,
	"./SpinLago_058.webp": 15254,
	"./SpinLago_059.webp": 13772,
	"./SpinLago_060.webp": 28153,
	"./SpinLago_061.webp": 76794,
	"./SpinLago_062.webp": 95943,
	"./SpinLago_063.webp": 35325,
	"./SpinLago_064.webp": 54195,
	"./SpinLago_065.webp": 33631,
	"./SpinLago_066.webp": 7633,
	"./SpinLago_067.webp": 77804,
	"./SpinLago_068.webp": 71944,
	"./SpinLago_069.webp": 65130,
	"./SpinLago_070.webp": 38402,
	"./SpinLago_071.webp": 27464,
	"./SpinLago_072.webp": 89556
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51217;